<button
  [attr.aria-label]="'rrs.a11y.scrollToTop' | cxTranslate"
  class="btn btn-primary btn-icon scroll-to-top"
  [ngClass]="{ 'scroll-to-top--active': windowScrolled }"
  (click)="scrollToTop()">
  <rrs-icon [icon]="iconTypeList.CHEVRON_UP" [size]="16"></rrs-icon>
</button>
